import { path } from 'ramda';

import { TWITTER_CONVERSION_OBJECT } from 'app/analytics/constants/pixelConstants';

const twttr = key =>
  key && window.etp.analytics?.twttr(key, TWITTER_CONVERSION_OBJECT);

const trackTwttr = () =>
  twttr(path(['etp', 'config', 'analytics', 'twitterPixelKey'], window));

export { twttr, trackTwttr };
